import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBrain, faListOl } from "@fortawesome/free-solid-svg-icons";

export const SHOW_CHAT_CAMERA_IN_CHAT = true;

// Gates the desktop "Zelf uitwerken" foto-pair flow (pair-uitnodiging in
// hero, snap-on-button-press, AI nakijken-foto). On everywhere — kept as
// a named constant so we can flip back to env-gated rollout in one line
// if anything regresses in prod.
export const ZELF_UITWERKEN_FOTO_PAIR = true;

// Shared feature parts: background colors (single source of truth)
export const FEATURE_BG_COLORS = {
  hints: "bg-mathyellow",
  stappenplan: "bg-info",
  theorie: "bg-theorie",
  bijlesbot: "bg-mathorange",
  oefentoets: "bg-emerald-500",
  begripvraag: "bg-pink-600"
} as const;

export const FEATURE_CARDS = [
  {
    title: "Hints",
    color: FEATURE_BG_COLORS.hints,
    icon: (
      <svg
        className="w-7 h-7 text-white"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        stroke="white"
        viewBox="0 0 24 24"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
          stroke="white"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
  {
    title: "Stappenplan",
    color: FEATURE_BG_COLORS.stappenplan,
    icon: (
      <svg
        className="w-7 h-7 text-white"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        stroke="white"
        viewBox="0 0 24 24"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
          stroke="white"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
  {
    title: "Theorie",
    color: FEATURE_BG_COLORS.theorie,
    icon: (
      <svg
        className="w-7 h-7 text-white"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        stroke="white"
        viewBox="0 0 24 24"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
          stroke="white"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
  {
    title: "Bijlesbot",
    color: FEATURE_BG_COLORS.bijlesbot,
    icon: (
      <svg
        className="w-7 h-7 text-white"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        stroke="white"
        viewBox="0 0 24 24"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
          stroke="white"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
  {
    title: "Begripvraag",
    description: "Na elke stap een korte vraag om je begrip te toetsen.",
    color: FEATURE_BG_COLORS.begripvraag,
    icon: <FontAwesomeIcon icon={faBrain} className="w-5 h-5 text-white" />
  },
  {
    title: "Oefentoets",
    color: FEATURE_BG_COLORS.oefentoets,
    icon: (
      <svg
        className="w-7 h-7 text-white"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        stroke="white"
        viewBox="0 0 24 24"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
          stroke="white"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
];

// Desktop feature items used in Hero right column (cards layout)
export const FEATURE_CARDS_DESKTOP = [
  {
    title: "Hints die je op weg helpen wanneer je vastloopt",
    description: "Iedere uitleg begint met een hint die je opweg helpt.",
    color: FEATURE_BG_COLORS.hints,
    textBlack: false,
    icon: (
      <svg
        className="w-4 h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2.5}
          d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
        />
      </svg>
    )
  },
  {
    title: "Stappenplannen die ook uitleggen waarom je iedere stap zet",
    description: "De oplossing wordt opgedeeld in duidelijke stappen.",
    color: FEATURE_BG_COLORS.stappenplan,
    textBlack: false,
    icon: <FontAwesomeIcon icon={faListOl} className="w-4 h-4" />
  },
  {
    title:
      "Theorieblokjes die je bij iedere stap de belangrijke theorie uitleggen",
    description: "Relevante theorie direct bij elke stap van de uitwerking.",
    color: FEATURE_BG_COLORS.theorie,
    textBlack: false,
    icon: (
      <svg
        className="w-4 h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2.5}
          d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
        />
      </svg>
    )
  },
  {
    title: "Een bijlesbot om alle vragen te stellen die je daarna nog hebt",
    description: "Stel vragen aan je persoonlijke tutor tot je het begrijpt.",
    color: FEATURE_BG_COLORS.bijlesbot,
    textBlack: false,
    icon: (
      <svg
        className="w-4 h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2.5}
          d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
        />
      </svg>
    )
  },
  {
    title: "Oefentoetsen om extra te oefenen voor je toets",
    description: "WisWiz oefentoetsen die aansluiten op je hoofdstuk.",
    color: FEATURE_BG_COLORS.oefentoets,
    textBlack: false,
    icon: (
      <svg
        className="w-4 h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2.5}
          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
        />
      </svg>
    )
  }
];
